// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionInProcess_container__EafFa","box":"SubscriptionInProcess_box__wlxBW","icon":"SubscriptionInProcess_icon__laGPt","pop":"SubscriptionInProcess_pop__XVlMQ"};